var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.07C10.3998 10.07 9.08984 8.76 9.08984 7.16C9.08984 5.56 10.3998 4.25 11.9998 4.25C13.5998 4.25 14.9098 5.56 14.9098 7.16C14.9098 8.76 13.5998 10.07 11.9998 10.07ZM11.9998 5.75C11.2198 5.75 10.5898 6.38 10.5898 7.16C10.5898 7.94 11.2198 8.57 11.9998 8.57C12.7798 8.57 13.4098 7.94 13.4098 7.16C13.4098 6.38 12.7798 5.75 11.9998 5.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78988 19.7502C5.18988 19.7502 3.87988 18.4402 3.87988 16.8402C3.87988 15.2402 5.18988 13.9302 6.78988 13.9302C8.38988 13.9302 9.69988 15.2402 9.69988 16.8402C9.69988 18.4402 8.38988 19.7502 6.78988 19.7502ZM6.78988 15.4302C6.00988 15.4302 5.37988 16.0602 5.37988 16.8402C5.37988 17.6202 6.00988 18.2502 6.78988 18.2502C7.56988 18.2502 8.19988 17.6202 8.19988 16.8402C8.19988 16.0602 7.55988 15.4302 6.78988 15.4302Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2098 19.7502C15.6098 19.7502 14.2998 18.4402 14.2998 16.8402C14.2998 15.2402 15.6098 13.9302 17.2098 13.9302C18.8098 13.9302 20.1198 15.2402 20.1198 16.8402C20.1198 18.4402 18.8198 19.7502 17.2098 19.7502ZM17.2098 15.4302C16.4298 15.4302 15.7998 16.0602 15.7998 16.8402C15.7998 17.6202 16.4298 18.2502 17.2098 18.2502C17.9898 18.2502 18.6198 17.6202 18.6198 16.8402C18.6198 16.0602 17.9898 15.4302 17.2098 15.4302Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore2);
export default __webpack_public_path__ + "static/media/more-2.601ba72a.svg";
export { ForwardRef as ReactComponent };